// CSC-only WhatsApp proposal message builder.
// Extracted verbatim from commercialSolarCalculator.jsx (buildMsg) so both the
// old calculator and the Combined tab can share one source of truth.
// NO RSC imports — commercial (CSC) only.

const fmt   = n => Number(n).toLocaleString('en-MY', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
const fmtRM = n => 'RM ' + fmt(n);

export function buildCscWhatsAppMsg(r, lang) {
    const hasBatt   = r.battKwh > 0;
    const battPart  = hasBatt ? ` + ${r.battKwh}kWh Battery` : '';
    const panelPart = r.panels ? ` (${r.panels} panel)` : '';
    const header    = `${r.kwp}kWp${panelPart}${battPart}`;
    const pct       = r.billSavingPct;
    const billStr   = r.bill > 0 ? ` (${fmtRM(Math.round(r.bill))})` : '';
    const co        = r.company ? r.company + '\n' : '';
    const hasDisc   = r.discount > 0;
    const isSare    = r.genMode === 'sare';

    const pkgBlock = label => {
        const isCN = lang === 'zh';
        const isMY = lang === 'ms';
        const lines = [];
        if (r.panels > 0) {
            if (isCN)       lines.push(`✅ ${r.panels}x Trina 全球Tier 1太阳能电板`);
            else if (isMY)  lines.push(`✅ ${r.panels}x Panel Solar Trina (Global Tier 1)`);
            else            lines.push(`✅ ${r.panels}x Trina Solar Panels (Global Tier 1)`);
        }
        if (r.kw) lines.push(`✅ Inverter = ${r.kw}kW`);
        if (hasBatt) {
            if (isCN)       lines.push(`✅ ${r.battKwh}kWh Battery`);
            else if (isMY)  lines.push(`✅ ${r.battKwh}kWh Bateri`);
            else            lines.push(`✅ ${r.battKwh}kWh Battery`);
        }
        if (isCN)       lines.push(isSare ? `✅ 0 安装费 & 包括A-Z政府申请手续` : `✅ 包括安装费 & A-Z政府申请手续`);
        else if (isMY)  lines.push(isSare ? `✅ Pemasangan PERCUMA & Permohonan Kerajaan A-Z` : `✅ Pemasangan & Permohonan Kerajaan A-Z`);
        else            lines.push(isSare ? `✅ FREE Installation & A-Z Government Application` : `✅ Installation & A-Z Government Application`);
        if (isCN)       lines.push(`✅ 10年 全球Tier 1 Inverter保修`);
        else if (isMY)  lines.push(`✅ Waranti 10 tahun Inverter (Global Tier 1)`);
        else            lines.push(`✅ 10-year Global Tier 1 Inverter Warranty`);
        if (hasBatt) {
            if (isCN)       lines.push(`✅ 10年 Battery保修`);
            else if (isMY)  lines.push(`✅ Waranti 10 tahun Bateri`);
            else            lines.push(`✅ 10-year Battery Warranty`);
        }
        if (isCN)       lines.push(`✅ 15年 Trina 全球Tier 1太阳能电板保修`);
        else if (isMY)  lines.push(`✅ Waranti 15 tahun Panel Solar Trina (Global Tier 1)`);
        else            lines.push(`✅ 15-year Trina Solar Panel Warranty (Global Tier 1)`);
        if (isCN)       lines.push(`✅ 30年 太阳能电板发电功效`);
        else if (isMY)  lines.push(`✅ Jaminan Prestasi 30 tahun Panel Solar`);
        else            lines.push(`✅ 30-year Solar Panel Performance Guarantee`);
        const yrs = isSare ? 20 : 1;
        if (isCN)       lines.push(`✅ ${yrs}年Maintenance保修`);
        else if (isMY)  lines.push(`✅ Waranti Penyelenggaraan ${yrs} tahun`);
        else            lines.push(`✅ ${yrs}-year Maintenance Warranty`);
        return `\n--------------------------------\n💼 【 ${label} 】\n${lines.join('\n')}`;
    };

    const costBlock = (capLabel, discLabel, nettLabel) =>
        hasDisc
            ? `⚡ ${capLabel} = ~${fmtRM(Math.round(r.capitalCostRaw))}~\n⚡ ${discLabel} = -${fmtRM(Math.round(r.discount))}\n⚡ *${nettLabel} = ${fmtRM(Math.round(r.capitalCost))}*`
            : `⚡ ${capLabel} = ${fmtRM(Math.round(r.capitalCost))}`;

    if (lang === 'en') {
        if (isSare) return (
`${co}*Commercial Proposal*
${header}
SARE Program Zero Capex
⚡ 20Years Contract
⚡ After 20years, solar system is YOURS
⚡ Capital Cost = RM0
⚡ Maintenance = RM 0/year

⚡ SARE rate = ${r.sareRate}/kWh = ${fmtRM(Math.round(r.savingMo))}
⚡ *Total 10 Year Saving = ${fmtRM(Math.round(r.saving10))}*
⚡ *Total 20 Year Saving = ${fmtRM(Math.round(r.saving20))}*
${pkgBlock('Package Includes')}`);
        return (
`${co}*Commercial Proposal*
${header}
${costBlock('Capital Cost', 'Discount', 'Nett Cost')}
⚡ Maintenance = ${fmtRM(r.maintenance)}/year

⚡ *Monthly Saving = ${fmtRM(Math.round(r.savingMo))}*${pct ? `\nEstimate saving ${pct.toFixed(1)}% of bill${billStr}` : ''}
⚡ *Total 10 Year Saving = ${fmtRM(Math.round(r.saving10))}*
⚡ *Total 20 Year Saving = ${fmtRM(Math.round(r.saving20))}*

⚡ *Yearly Yield Rate (nett) = ${r.yieldRate.toFixed(2)}%/year*
⚡ *ROI = ${r.roi.toFixed(2)} year*

After Tax Relief (${r.taxPct}%)
⚡ Cost = ${fmtRM(Math.round(r.afterTaxCost))}
⚡ *ROI = ${r.roiAfterTax.toFixed(2)} year*
${pkgBlock('Package Includes')}`);
    }

    if (lang === 'zh') {
        if (isSare) return (
`${co}*商业太阳能方案*
${header}
SARE 零资本计划
⚡ 20年合约
⚡ 20年后，太阳能系统归您所有
⚡ 资本成本 = RM0
⚡ 维护费用 = RM 0/年

⚡ SARE 费率 = ${r.sareRate}/kWh = ${fmtRM(Math.round(r.savingMo))}
⚡ *10年总节省 = ${fmtRM(Math.round(r.saving10))}*
⚡ *20年总节省 = ${fmtRM(Math.round(r.saving20))}*
${pkgBlock('配套包括')}`);
        return (
`${co}*商业太阳能方案*
${header}
${costBlock('资本成本', '折扣', '优惠后价格')}
⚡ 维护费用 = ${fmtRM(r.maintenance)}/年

⚡ *每月节省 = ${fmtRM(Math.round(r.savingMo))}*${pct ? `\n估计节省电费 ${pct.toFixed(1)}%${billStr}` : ''}
⚡ *10年总节省 = ${fmtRM(Math.round(r.saving10))}*
⚡ *20年总节省 = ${fmtRM(Math.round(r.saving20))}*

⚡ *年回报率（净值）= ${r.yieldRate.toFixed(2)}%/年*
⚡ *回本年限 = ${r.roi.toFixed(2)} 年*

税务减免后（${r.taxPct}%）
⚡ 成本 = ${fmtRM(Math.round(r.afterTaxCost))}
⚡ *回本年限 = ${r.roiAfterTax.toFixed(2)} 年*
${pkgBlock('配套包括')}`);
    }

    if (lang === 'ms') {
        if (isSare) return (
`${co}*Cadangan Solar Komersial*
${header}
Program SARE Tanpa Modal
⚡ Kontrak 20 Tahun
⚡ Selepas 20 tahun, sistem solar adalah MILIK ANDA
⚡ Kos Modal = RM0
⚡ Penyelenggaraan = RM 0/tahun

⚡ Kadar SARE = ${r.sareRate}/kWh = ${fmtRM(Math.round(r.savingMo))}
⚡ *Jumlah Penjimatan 10 Tahun = ${fmtRM(Math.round(r.saving10))}*
⚡ *Jumlah Penjimatan 20 Tahun = ${fmtRM(Math.round(r.saving20))}*
${pkgBlock('Pakej Termasuk')}`);
        return (
`${co}*Cadangan Solar Komersial*
${header}
${costBlock('Kos Modal', 'Diskaun', 'Kos Selepas Diskaun')}
⚡ Penyelenggaraan = ${fmtRM(r.maintenance)}/tahun

⚡ *Penjimatan Bulanan = ${fmtRM(Math.round(r.savingMo))}*${pct ? `\nAnggaran jimat ${pct.toFixed(1)}% daripada bil${billStr}` : ''}
⚡ *Jumlah Penjimatan 10 Tahun = ${fmtRM(Math.round(r.saving10))}*
⚡ *Jumlah Penjimatan 20 Tahun = ${fmtRM(Math.round(r.saving20))}*

⚡ *Kadar Hasil Tahunan (nett) = ${r.yieldRate.toFixed(2)}%/tahun*
⚡ *ROI = ${r.roi.toFixed(2)} tahun*

Selepas Pelepasan Cukai (${r.taxPct}%)
⚡ Kos = ${fmtRM(Math.round(r.afterTaxCost))}
⚡ *ROI = ${r.roiAfterTax.toFixed(2)} tahun*
${pkgBlock('Pakej Termasuk')}`);
    }
}

// ───────────────────────────────────────────────────────────────────────────
// RSC-style (AI BESS 360) WhatsApp message, fed by CSC's own data object.
// Mirrors residentialSolarCalculatorV2.buildAtapStyleMsg LAYOUT only — NO RSC
// imports, NO residential promo block. `lang` = 'en' | 'zh' | 'ms' (same codes
// the ModeToggle and buildCscWhatsAppMsg use — NOT 'cn'/'my').
// ───────────────────────────────────────────────────────────────────────────

const num = (n) => Math.round(Number(n) || 0).toLocaleString();

// Pretty-case a brand key for display (goodwe → GoodWe, solis → Solis, …).
const brandDisp = (b) => {
    const k = String(b || 'goodwe').toLowerCase();
    if (k === 'goodwe') return 'GoodWe';
    if (k === 'solis') return 'Solis';
    if (k === 'huawei') return 'Huawei';
    return k.charAt(0).toUpperCase() + k.slice(1);
};

// The 配套包括 / Package Includes block (bullets only), built from d.
function cscIncludesBullets(d, isCN, isMY) {
    const brandLabel = brandDisp(d.brandLabel);
    const lines = [];
    if (isCN) lines.push(`✅ ${d.panels}x ${d.panelWatt}W Tier 1 太阳能电板`);
    else      lines.push(`✅ ${d.panels}x ${d.panelWatt}W Tier 1 Solar Panels`);
    lines.push(`✅ Inverter ${d.inverterKw}kW ${brandLabel}`);
    if (Number(d.battery) > 0) lines.push(`✅ Battery ${d.battery}kWh`);
    if (isCN) lines.push(`✅ 安装费 & 包括申请手续`);
    else      lines.push(`✅ Installation & application handling`);
    if (isCN) lines.push(`✅ 10年 ${brandLabel} Inverter 保修`);
    else      lines.push(`✅ 10-Year ${brandLabel} Inverter Warranty`);
    if (Number(d.battery) > 0) {
        if (isCN) lines.push(`✅ 10年 Battery 保修`);
        else      lines.push(`✅ 10-Year Battery Warranty`);
    }
    if (isCN) lines.push(`✅ 15年 太阳能电板保修`);
    else      lines.push(`✅ 15-Year Solar Panel Warranty`);
    if (isCN) lines.push(`✅ 30年 太阳能电板发电功效`);
    else      lines.push(`✅ 30-Year Panel Performance`);
    const omLabel = d.omPkg === 'basic' ? (isCN ? '基础' : 'Basic') : (isCN ? '高级' : 'Premium');
    if (isCN) lines.push(`✅ ${omLabel} O&M Maintenance 配套`);
    else      lines.push(`✅ ${omLabel} O&M Maintenance package`);
    return lines.join('\n');
}

// The per-option body (kWp/battery, savings, ROI, CC, Cash) — no includes block.
function cscOptionBody(d, isCN, isMY) {
    const battDesc = Number(d.battery) > 0
        ? `${d.battery}kWh Battery`
        : (isCN ? '无电池' : isMY ? 'Tiada Bateri' : 'No Battery');

    const ccLabel = isCN ? '36M CC 0% 分期' : isMY ? '36B CC 0% Ansuran' : '36M CC 0% Instalment';
    const cashLabel = isCN ? 'Cash (省更多)' : isMY ? 'Tunai (Jimat Lebih)' : 'Cash (Save More)';
    const discWord = isMY ? 'diskaun' : 'discount';

    let m = `🔆 *${d.kwp}kWp · ${battDesc}*\n`;
    if (isCN)      m += `💰 省电: RM ${num(d.savingMo)}++/月\n📈 回本ROI: ${d.roi} 年 & 回酬Return: ${d.ret}%\n\n`;
    else if (isMY) m += `💰 Penjimatan: RM ${num(d.savingMo)}++/bulan\n📈 ROI: ${d.roi} tahun & Pulangan: ${d.ret}%\n\n`;
    else           m += `💰 Est. Savings: RM ${num(d.savingMo)}++/month\n📈 ROI: ${d.roi} yrs & Return: ${d.ret}%\n\n`;

    m += Number(d.ccDisc) > 0
        ? `💳 ${ccLabel}: ~RM ${num(d.ccOri)}~ RM${num(d.ccFinal)} (-RM${num(d.ccDisc)} ${discWord})\n`
        : `💳 ${ccLabel}: RM ${num(d.ccOri)}\n`;
    m += Number(d.cashDisc) > 0
        ? `💵 ${cashLabel}: ~RM ${num(d.cashOri)}~ RM${num(d.cashFinal)} (-RM${num(d.cashDisc)} ${discWord})\n`
        : `💵 ${cashLabel}: RM ${num(d.cashOri)}\n`;
    return m;
}

export function buildCscBessStyleMsg(d, lang) {
    if (!d) return '';
    const isCN = lang === 'zh', isMY = lang === 'ms';
    const cname = (d.name || '').trim() ? `${(d.name || '').trim()} ` : '';

    let m = isCN ? `✨ *${cname}商业太阳能方案* ✨\n`
          : isMY ? `✨ *${cname}Cadangan Solar Komersial* ✨\n`
          : `✨ *${cname}Commercial Solar Proposal* ✨\n`;

    if (Number(d.usageKwh) > 0) {
        const billStr = Number(d.bill) > 0 ? `RM ${num(d.bill)} · ` : '';
        if (isCN)      m += `💸 Bill : ${billStr}${num(d.usageKwh)}kWh\n⚡ 日间自用 : ${d.selfPct}%\n`;
        else if (isMY) m += `💸 Bil : ${billStr}${num(d.usageKwh)}kWh\n⚡ Guna Siang : ${d.selfPct}%\n`;
        else           m += `💸 Bill : ${billStr}${num(d.usageKwh)}kWh\n⚡ Day-time self-use : ${d.selfPct}%\n`;
    }

    m += '\n' + cscOptionBody(d, isCN, isMY);

    const includesHeader = isCN ? '【 配套包括 】' : isMY ? '【 Pakej Termasuk 】' : '【 Package Includes 】';
    m += `\n--------------------------------\n📦 ${includesHeader}\n`;
    m += cscIncludesBullets(d, isCN, isMY);
    return m;
}

export function buildCscBessComboMsg(dA, dB, lang) {
    if (!dA || !dB) return '';
    const isCN = lang === 'zh', isMY = lang === 'ms';
    const cname = (dA.name || '').trim() ? `${(dA.name || '').trim()} ` : '';

    let m = isCN ? `✨ *${cname}商业太阳能 A 对比 B* ✨\n`
          : isMY ? `✨ *${cname}Solar Komersial — A vs B* ✨\n`
          : `✨ *${cname}Commercial Solar — A vs B* ✨\n`;

    if (Number(dA.usageKwh) > 0) {
        const billStr = Number(dA.bill) > 0 ? `RM ${num(dA.bill)} · ` : '';
        if (isCN)      m += `💸 Bill : ${billStr}${num(dA.usageKwh)}kWh\n⚡ 日间自用 : ${dA.selfPct}%\n`;
        else if (isMY) m += `💸 Bil : ${billStr}${num(dA.usageKwh)}kWh\n⚡ Guna Siang : ${dA.selfPct}%\n`;
        else           m += `💸 Bill : ${billStr}${num(dA.usageKwh)}kWh\n⚡ Day-time self-use : ${dA.selfPct}%\n`;
    }

    m += `\n*Option A*\n` + cscOptionBody(dA, isCN, isMY);
    m += `\n━━━━━━━━━━━━━━━━\n`;
    m += `*Option B*\n` + cscOptionBody(dB, isCN, isMY);

    const includesHeader = isCN ? '【 配套包括 】' : isMY ? '【 Pakej Termasuk 】' : '【 Package Includes 】';
    m += `\n--------------------------------\n📦 ${includesHeader}\n`;
    m += cscIncludesBullets(dA, isCN, isMY);
    return m;
}
